import React from 'react';
import { Route, Routes } from 'react-router-dom';
import PermissionList from './PermissionList';
import './index.css';

const Settings = () => {
  return (
    <div className="settings">
      <Routes>
        <Route exact path={`/permissions/list`} element={<PermissionList />} />
      </Routes>
    </div>
  );
};


export default Settings
